<script>
  import { Link } from "svelte-routing";
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Mea+Culpa&display=swap');
html,body ,
h1{
	font: 400 2.615rem/2.675rem 'Mea Culpa', cursive;
}

h5{
	font: 400 2.015rem/2.075rem 'Mea Culpa', cursive;
}
	p {
	font: 100 1.615rem/1.675rem 'Mea Culpa', cursive;
}	j {
	font: 100 1.815rem/1.875rem 'Mea Culpa', cursive;
}
</style> 
        <div 
		style="background-image: url(https://mesinkasir.github.io/larapos/img/wedding/onlinewedding.jpg);
		background-repeat: no-repeat;
		background-attachment: fixed;
  background-position: center; 
   background-size: cover;
		"
		>
           <div class="container">
		   <div class="row py-5">
		   <div class="col-12 p-3 p-md-5 text-center"></div>
		   <div class="col-12 p-3 p-md-5">
		   <div class="bg-white rounded shadow p-3 p-md-5 text-center" style="opacity:0.9;">
		   <h1>- Map Location -</h1>
		   <p>Lokasi resepsi dan acara</p>
		   <hr/>
		   <div class="ratio ratio-16x9">
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52864.87101914459!2d-118.36149759132728!3d34.09374583208188!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2bf07045279bf%3A0xf67a9a6797bdfae4!2sHollywood%2C%20Los%20Angeles%2C%20CA%2C%20USA!5e0!3m2!1sen!2sid!4v1645532425318!5m2!1sen!2sid" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
</div>
		   
		   <hr/>
		  <h3>
		 Hollywood USA<br/>Rt : 021/Rw :008 <br/>Ds : Keris <br/>kec : manusa  <br/>Kab : Miami <br/> USA
		  </h3>
		  <hr/>
<Link to="/start" class="btn btn-dark">Back to menu</Link>
		   </div>
		   </div>
		   </div>
		   </div>
		    <div class="col-12 p-1 text-center">
			<small>wedding online <a href="https://creativebydre.vercel.app">creative by dre</a></small>
			</div>
    </div>
